
import { myConst } from "@/config/";
import { DATA_TYPE_CONFIG } from "@/utils/dataType";

export const makeMarkerHtml = (v, source) => {
    const htmlTp = myConst.markerHtml;
    let html = htmlTp
        .replace("{{type}}", v.type)
        .replace("{{imgBg}}", v.imgBg)
        .replace("{{id}}", v.id)
        .replace('{{name}}', v.name);
    if (source === 'pin') {
        // 只有街道 才在 marker 上显示结果
        if (DATA_TYPE_CONFIG[v.type].showOnMarker) {
            if (v.lastUpdate + myConst.updateTimeout > Date.now()) {
                html = html
                    .replace('{{uCount}}', v.uCount)
                    .replace('{{eCount}}', v.eCount)
                    .replace('{{res}}', 'res');
            }
        }
    } else if (source === 'getItem') {
        const marker_res = !isNaN(v.cCount) ? 'res' : ''; // 如果获取到的没有结果 就不要在 marker 上面显示
        html = html
            .replace('{{uCount}}', v.uCount)
            .replace('{{eCount}}', v.eCount)
            .replace('{{res}}', marker_res)
            .replace('{{selected}}', '__sele__');
    }
    return html;
};


export const clearAllMarker = function (map, mkArr) {
    for (let i = mkArr.length - 1; i >= 0; i--) {
        map.removeOverlay(mkArr[i]);
        mkArr.splice(i, 1);
    }
};